import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../config/axios";
import { errorHandler } from "../../../helpers/handlers";

const initialState = {
  data: [],
  pageLoading: false,
  error: null,
};

const slice = createSlice({
  name: "aiConversations",
  initialState,
  reducers: {
    clearConversationsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAiConversations.pending, (state) => {
        state.pageLoading = true;
        state.error = null;
      })
      .addCase(fetchAiConversations.fulfilled, (state, action) => {
        state.pageLoading = false;
        state.data = action.payload.data || [];
      })
      .addCase(fetchAiConversations.rejected, (state, action) => {
        state.pageLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearConversationsError } = slice.actions;

export const fetchAiConversations = createAsyncThunk(
  "aiConversations/fetch",
  async ({ sampled = true, limit = 20 } = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({
        sampled: String(sampled),
        limit: String(limit),
      });
      const response = await api.get(
        `/admin/ai/conversations?${params.toString()}`
      );
      return response.data.payload || { data: [] };
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(
        error.response?.data?.errors?.global || error.message
      );
    }
  }
);

export default slice.reducer;
